<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        v-for="(item, index) in updateErrors"
        :key="index"
      >
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          label="Supplier ID"
          required
          disabled
          v-model="supplierId"
        ></v-text-field>
      </v-col>
      <v-col
        cols="8"
      >
        <v-text-field
          label="Name"
          required
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          label="Date Partnered"
          type="date"
          required
          v-model="subscriptionDate"
        ></v-text-field>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          label="Contact No. 1"
          v-model="contactNo1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          label="Contact No. 2"
          v-model="contactNo2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
      >
        <v-text-field
          label="Address"
          v-model="address"
        ></v-text-field>
      </v-col>
      <v-col
        cols="2"
        align-self="end"
      >
        <v-btn
          color="blue"
          @click="initUpdate"
          :loading="updating"
        >Save</v-btn>
      </v-col>
      <v-col
        cols="1"
        align-self="end"
      >
        <v-btn
          color="red"
          dark
          @click="closeDialog"
        >Close</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'vEditSupplier',
    props: {
      propSupplierId: {
        type: String,
        default: '',
      },
      propSupplierData: Object,
    },
    data () {
      return {
        name: null,
        subscriptionDate: null,
        address: null,
        contactNo1: null,
        contactNo2: null,
      }
    },
    computed: {
      ...mapState({
        updating: state => state.supplier.updating,
        updateErrors: state => state.supplier.updateErrors,
        updateSuccess: state => state.supplier.updateSuccess,
      }),
      supplierId (val) {
        return this.propSupplierId
      },
    },
    watch: {
      updateSuccess (val) {
        if (val) {
          this.closeDialog()
        }
      },
      propSupplierId () {
        this.supplierIdSideEffect()
      },
    },
    methods: {
      ...mapActions({
        update: 'supplier/update',
      }),
      closeDialog () {
        this.$emit('close-dialog')
      },
      supplierIdSideEffect () {
        this.name = this.propSupplierData.name
        this.address = this.propSupplierData.address
        this.subscriptionDate = this.propSupplierData.subscription_date
        this.contactNo1 = this.propSupplierData.contact_no_1
        this.contactNo2 = this.propSupplierData.contact_no_2
      },
      initUpdate () {
        const data = {
          name: this.name,
          subscription_date: this.subscriptionDate,
          address: this.address,
          contact_no_1: this.contactNo1,
          contact_no_2: this.contactNo2,
        }
        this.update({
          id: this.supplierId,
          data,
        })
      },
    },
  }
</script>
